import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { GlobalMarginMergeModal } from "../../Margin/GlobalMarginMergeModal";

export function GlobalMarginMerge() {
  const { id, marginId } = useParams<{
    id: string;
    marginId: string;
  }>();

  const history = useHistory();
  const handleClose = useCallback(() => {
    history.push(`/companies/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return <GlobalMarginMergeModal companyId={id} handleClose={handleClose} marginId={marginId} />;
}
